import React from 'react';
import moment from 'js-utils/moment';

import Tag from 'eventbrite_design_system/tag/Tag';
import DateRangePicker from 'eventbrite_design_system/datePicker/DateRangePicker';
import {
    ORANGE_COLOR,
    START_DATE,
} from 'eventbrite_design_system/datePicker/constants';
import { ISO_8601_DATE_FORMAT } from 'eventbrite_design_system/utils/date';

import Filter from './Filter';

import { DROPDOWN_FILTER_PROP_MAP } from '../../constants';

import './searchFilters.scss';

const DATEPICKER_DEFAULT_DISPLAY_FORMAT = 'MMM D';

export default ({
    type,
    handleSelect,
    value,
    locationSlug,
    handleClear,
    shouldShowPicker,
    onDatePickerBlur,
    onCancelPicker,
    isBotRequest,
    isLoading,
}) => {
    let component = (
        <Filter
            type={type}
            handleSelect={handleSelect}
            value={value}
            locationSlug={locationSlug}
            handleClear={handleClear}
            isBotRequest={isBotRequest}
            isLoading={isLoading}
            {...DROPDOWN_FILTER_PROP_MAP.dates}
        />
    );

    if (shouldShowPicker) {
        component = (
            <Tag
                showOverflow={true}
                isStatic={true}
                isClosable={true}
                onClose={onCancelPicker}
            >
                <DateRangePicker
                    color={ORANGE_COLOR}
                    onBlur={onDatePickerBlur}
                    inputDisplayFormat={DATEPICKER_DEFAULT_DISPLAY_FORMAT}
                    initialFocusedInput={START_DATE}
                    minDate={moment().format(ISO_8601_DATE_FORMAT)}
                />
            </Tag>
        );
    }

    return component;
};
